import styled from "styled-components";

export const StyledSupportUserWrapper = styled.div`
  .support-user-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;

    &__create {
      display: inline-grid;
      justify-content:  end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      &__create {
        justify-content: start;
      }
    }
  }
`;

export const StyledSupportUserCreate = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledSupportUserCreateForm = styled.div`
  max-width: 270px;
  width: 100%;
  .generate-data {
    font-size: 14px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &__value {
      width: 100%;
      font-weight: 700;
      overflow-wrap: break-word;
    }
  }
`;

export const StyledSupportUserDetailsWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
    .content-head {
      padding: 20px 0;
      display: grid;
      grid-template-columns: max-content 175px;
      grid-gap: 20px;
      @media screen and (max-width: 768px) {
        grid-template-columns: 100%;
      }
    }
  }
  
  .support-user-details-head {
    margin-bottom: 20px;
  }
  .support-user-info {
    display: grid;
    grid-template-columns: minmax(min-content, max-content) 1fr;
    grid-gap: 50px;
    @media screen and (max-width: 992px) {
      grid-template-columns: 100%;
      grid-gap: 30px;
    }

    &__content {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 250px));
      grid-gap: 30px;
    }
    &__row {
      display: grid;
      grid-template-columns: 20px 1fr;
      grid-gap: 20px;
      align-items: center;
      span {
        color: #162954;
        font-size: 20px;
      }
    }
    &__email p {
      max-width: 210px;
      width: 100%;
      overflow-wrap: break-word;
      cursor: pointer;
    }
  }

  .support-user {
    display: grid;
    grid-template-columns: 70px minmax(0, auto);
    grid-gap: 20px;
    align-items: center;
    &__name {
      color: #162954;
      font-size: 18px;
      font-weight: 600;
      display: flex;
      flex-wrap: wrap;
      span {
        opacity: 0.25;
      }
    }
    &__image {
      width: 70px;
      height: 70px;
      color: #fff;
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #29DEAE;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
  
  .projects-table {
    &__head, &__row {
      grid-template-columns: 130px repeat(3, 1fr);
    }
  }
`;